export default "__VITE_ASSET__DPgTgrHC__"